export default __webpack_public_path__ + "static/media/roadmap_path_mobile.afd96e3a.png";